import AddResource from "@/components/optimization/resource/create/AddResource.vue";
import VehicleList from "@/components/vehicle/list/VehicleList.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import UploadFile from "@/components/optimization/upload-file/UploadFile.vue";
import ResourceListDatarutas from "@/components/optimization/datarutas/resource/ResourceList.vue";
import ListSelectedItemVehicle from "@/components/optimization/resource/ListSelectedItemVehicle.vue";
import NotAuthorized from "@/components/optimization/datarutas/NotAuthorized.vue";
import moduleSessionApi from "@/store/session-api/moduleSessionApi";
import DateUtils from "@/helpers/DateUtils.js";
import GenerateRepeat from "@/components/optimization/generate-repeat/GenerateRepeat.vue";
import OptimizationDownload from "@/components/optimization/OptimizationDownload.vue";
import {firebaseInstance as firebase} from "@/main";

export const listSelectVehicleMixin = {
	name: "ListSelectVehicle",
	data() {
		return {
			isSidebarAddActive: false,
			resourceMounted: false,
			resourceMountedDatarutas: false,
			searchQueryVehicle: null,
			searchQuery: "",
			uploadFileMounted: false,
			uploadFileUpdateMounted: false,
			showUploadFileOptimization: true,
			showSetEquivalenceOptimization: false,
			isDatarutasEnabled: false,
			resourceObject: {},
			isExpanded: false,
			generateRepeatMounted: false,
			isActiveDownload: false,
			searchFieldShipping: "Identification",
			activeDiscardedItemsPrompt: false,
			discardedItemsList: [],
			discardedItemsPerPage: 20,
			currentDiscardedItemsPage: 1,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			vehicleListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: [
					"id",
					"identification",
					"profile",
					"max_travel_distance",
					"max_travel_duration",
					"init_depot_name",
					"end_depot_name",
				],
				actionDropdown: false,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				CellRendererDemand: false,
				showItemsPerPage: false,
				showPopup: true,
				showButtonAdd: false,
				showButtonSelected: true,
			},
			vehicleListConfigDatarutas: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: ["identification", "name", "lastname", "username", "email", "status", "typology_name"],
				actionDropdown: false,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				CellRendererDemand: false,
				showItemsPerPage: false,
				showPopup: true,
				showButtonAdd: false,
				showButtonSelected: true,
			},
		};
	},
	components: {
		AddResource,
		VehicleList,
		VuePerfectScrollbar,
		UploadFile,
		ResourceListDatarutas,
		ListSelectedItemVehicle,
		NotAuthorized,
		GenerateRepeat,
		OptimizationDownload,
	},
	created() {
		if (!moduleSessionApi.isRegistered) {
			this.$store.registerModule("moduleSessionApi", moduleSessionApi);
			moduleSessionApi.isRegistered = true;
		}
		this.getSessionApiByToken();
	},
	watch: {
		resourceMounted(val) {
			if (val) {
				this.vehicleListConfig.tableOptions = false;
			}
		},
		uploadFileMounted(val) {
			if (!val) {
				this.$store.commit("vehicle/REMOVE_ALL_UPLOAD_FILE_VEHICLE");
				this.$store.commit("vehicle/REMOVE_ALL_CHECKED_UPLOAD_FILE_VEHICLE");
			}
		},
	},
	computed: {
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		getVehicleList() {
			return this.getFilteredVehicleList(this.resources, this.searchQueryVehicle, this.searchFieldShipping);
		},
		textSearch() {
			return (type) => {
				if (type === "search") return this.$t("NoResultsWereFoundForYourSearch");
				return this.$t("ThereIsNoDataToDisplayPleaseTryToAddNewRecords");
			};
		},
		getCheckedVehicles() {
			return this.$store.state.vehicle.checkedVehicles === undefined ||
				this.$store.state.vehicle.checkedVehicles === "" ||
				this.$store.state.vehicle.checkedVehicles === null
				? []
				: this.$store.state.vehicle.checkedVehicles;
		},
		getCheckedResourceDatarutas() {
			return this.$store.state.vehicle.checkedResourceDatarutas === undefined ||
				this.$store.state.vehicle.checkedResourceDatarutas === "" ||
				this.$store.state.vehicle.checkedResourceDatarutas === null
				? []
				: this.$store.state.vehicle.checkedResourceDatarutas;
		},
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		validateIdentification() {
			return this.resourceObject.hasOwnProperty("identification") &&
				(this.resourceObject.identification != undefined ||
					this.resourceObject.identification != null ||
					this.resourceObject.identification != "")
				? `(${this.resourceObject.identification})`
				: "";
		},
		searchSelected() {
			return this.$t(`${this.searchFieldShipping}`);
		},
		resources() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
		// Pagination computed properties for discarded items
		paginatedDiscardedItems() {
			const startIndex = (this.currentDiscardedItemsPage - 1) * this.discardedItemsPerPage;
			const endIndex = startIndex + this.discardedItemsPerPage;
			return this.discardedItemsList.slice(startIndex, endIndex);
		},
		totalDiscardedItemsPages() {
			return Math.ceil(this.discardedItemsList.length / this.discardedItemsPerPage);
		},
		showDiscardedItemsPagination() {
			return this.discardedItemsList.length > this.discardedItemsPerPage;
		},
	},
	methods: {
		showSidebar() {
			this.isSidebarAddActive = true;
		},
		closeSidebar() {
			this.isSidebarAddActive = false;
		},
		closePopupResourceAddEmit() {
			this.resourceMountedDatarutas = false;
		},
		closePopupUploadFileAdd() {
			this.uploadFileMounted = false;
		},
		showPopup() {
			this.resourceMounted = false;
			this.searchQuery = "";
		},
		closePopup() {
			this.uploadFileUpdateMounted = false;
		},
		setUploadFileOptimization(val) {
			this.showUploadFileOptimization = val;
		},
		setEquivalenceOptimization(val) {
			this.showSetEquivalenceOptimization = val;
		},
		updateSearchQuery(val) {
			this.$refs.VehicleListPopup.updateSearchQuery(val);
		},
		setAssignedResource() {
			let vehicleList = {};
			const payload = {
				pickups: {},
				deliveries: {},
				global_config: {
					init_date: DateUtils.toDefaultDateTime(this.standardInput["global_config"].init_date, "YYYY-MM-DD"),
					end_date: DateUtils.toDefaultDateTime(this.standardInput["global_config"].end_date, "YYYY-MM-DD"),
					init_hour: this.standardInput["global_config"].init_hour,
					end_hour: this.standardInput["global_config"].end_hour,
				},
			};
			if (this.getCheckedResourceDatarutas.length > 0)
				vehicleList["dararutas_resource_ids"] = this.getCheckedResourceDatarutas.map(({id}) => id);
			if (this.getCheckedVehicles.length > 0)
				vehicleList["serviroutes_vehicle_ids"] = this.getCheckedVehicles.map(({id}) => id);
			if (Object.entries(vehicleList).length > 0) payload.vehicles = vehicleList;
			this.$store
				.dispatch("moduleOptimization/generateStandardInputFilter", payload)
				.then((res) => {
					// Check if there are discarded items due to frequencies
					if (
						res.data &&
						res.data.warnings &&
						Array.isArray(res.data.warnings) &&
						res.data.warnings.length > 0
					) {
						const discardedItems = res.data.warnings.filter(
							(item) => typeof item === "string" && item.includes("discarded due to frequencies")
						);

						if (discardedItems.length > 0) {
							this.showDiscardedItemsPrompt(discardedItems);
						}
					}
					this.$store.commit("moduleOptimization/SET_VEHICLE_STANDARD_INPUT", res.data["vehicles"]);
					if (this.isExpanded) this.toggleAll();
					this.resourceMounted = false;
					this.resourceMountedDatarutas = false;
					this.searchQuery = "";
					return res;
				})
				.catch((err) => {
					if (this.getCheckedVehicles.length <= 0) {
						this.$vs.notify({
							color: "warning",
							title: this.$t("RouterSelection.Step2Title"),
							text: this.$t("RouterSelection.TotalResourceInsideToContinue"),
							time: 7000,
						});
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("ErrorTitle"),
							text: this.$t("ErrorMessage"),
							time: 7000,
						});
					}
					console.error(err);
					return err;
				});
		},
		async getSessionApiByToken() {
			try {
				const token = localStorage.getItem("accessToken");
				const response = await this.$store.dispatch("moduleSessionApi/getSessionApiByToken", token);
				if (response.data.hasOwnProperty("datarutas_company_id")) {
					this.isDatarutasEnabled = true;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async loginDatarutas() {
			await firebase.auth().signInAnonymously();
			this.openLoadingInDiv();
			this.$store
				.dispatch("moduleOptimization/datarutasLogin")
				.then((response) => {
					this.$vs.loading.close("#div-with-loading > .con-vs-loading");
					if (response.status === 200 && response.data.hasOwnProperty("datarutas_company_id")) {
						this.isDatarutasEnabled = true;
						this.$vs.notify({
							color: "success",
							title: this.$t("Login.Login"),
							text: this.$t("Login.YouHaveSuccessfullyLoggedInToDatarutas"),
							time: 9000,
						});
					} else {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Login.Login") + " " + "Datarutas",
							text: this.$t("Login.CouldNotConnectToDatarutas"),
							time: 9000,
						});
					}
				})
				.catch((err) => {
					this.$vs.loading.close("#div-with-loading > .con-vs-loading");
					this.$vs.notify({
						color: "danger",
						title: this.$t("Login.Login") + " " + "Datarutas",
						text: this.$t("Login.CouldNotConnectToDatarutas"),
						time: 9000,
					});
					console.error(err);
				});
		},
		openLoadingInDiv() {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6,
				text: this.$t("Login.ConnectingWithDatarutas"),
				textAfter: true,
				type: "point",
				background: "rgba(255, 255, 255, .9)",
			});
		},
		// Metodo auxiliar para agrupar elementos por 'original_identification'
		groupByOriginalIdentification(items) {
			return items.reduce((acc, item) => {
				const key = item.original_identification;
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
				return acc;
			}, {});
		},
		// Método generalizado para búsqueda y filtrado
		getFilteredVehicleList(items, searchQuery, searchField) {
			const groupedItems = this.groupByOriginalIdentification(items);
			if (!searchQuery || searchQuery.trim().length === 0) {
				return Object.entries(groupedItems);
			}
			const vehicleList = Object.entries(groupedItems)
				.map(([key, items]) => {
					if (searchField === "Identification") {
						const filteredItems = items.filter((item) =>
							item.identification.toLowerCase().includes(searchQuery.toLowerCase())
						);
						return filteredItems.length ? [key, filteredItems] : null;
					} else {
						return key.toString().toLowerCase().includes(searchQuery.toLowerCase()) ? [key, items] : null;
					}
				})
				.filter(Boolean);
			if (vehicleList.length > 0 && !this.isExpanded) this.toggleAll();
			return vehicleList;
		},
		setSearchField(val) {
			this.searchFieldShipping = val;
		},
		toggleAll() {
			this.$refs.listSelectedItemVehicle.toggleAll();
		},
		getExpanded(val) {
			this.isExpanded = val;
		},
		closePopupGenerateRepeatEmit() {
			this.generateRepeatMounted = false;
		},
		activeDownload() {
			this.isActiveDownload = true;
		},
		activePopup(val) {
			this.isActiveDownload = val;
		},
		showDiscardedItemsPrompt(discardedItems) {
			// Parse and translate the discarded items
			const translatedItems = discardedItems.map((item) => {
				// Parse the item string: "TYPE identifier, discarded due to frequencies."
				const parts = item.split(",");
				if (parts.length >= 2) {
					const typeAndIdentifier = parts[0].trim();
					// Split type and identifier
					const spaceIndex = typeAndIdentifier.indexOf(" ");
					if (spaceIndex !== -1) {
						const type = typeAndIdentifier.substring(0, spaceIndex).trim();
						const identifier = typeAndIdentifier.substring(spaceIndex + 1).trim();
						// Translate the type
						let translatedType = type;
						if (type === "PICKUP") {
							translatedType = this.$t("Frequency.DiscardedItems.Pickup");
						} else if (type === "DELIVERY") {
							translatedType = this.$t("Frequency.DiscardedItems.Delivery");
						} else if (type === "VEHICLE") {
							translatedType = this.$t("Frequency.DiscardedItems.Vehicle");
						}
						return `${translatedType} ${identifier}`;
					}
				}
				return item; // Return original if parsing fails
			});

			// Store the translated items and activate the prompt
			this.discardedItemsList = translatedItems;
			this.currentDiscardedItemsPage = 1; // Reset to first page
			this.activeDiscardedItemsPrompt = true;
		},
		// Pagination methods for discarded items
		changeDiscardedItemsPage(page) {
			if (page >= 1 && page <= this.totalDiscardedItemsPages) {
				this.currentDiscardedItemsPage = page;
			}
		},
		closeDiscardedItemsPrompt() {
			this.activeDiscardedItemsPrompt = false;
			this.currentDiscardedItemsPage = 1;
		},
	},
};
